module.exports = __webpack_public_path__ + "static/media/Property 1=Vàng.fc612eaa.png";